import axios from 'axios';

async function errorHandler(error) {
    if (error.response && error.response.data) {
        throw error.response.data;
    } else {
        throw error;
    }
}

export default {
    async listtodo(obj) {
        try {
            const url = `/tasktodo`;
            const { data } = await axios.get(url);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async detail(obj) {
        try {
            const { data: resp } = await axios.get(`tasktodo/detail/?key=${encodeURIComponent(obj.key)}`);
            return resp;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async doaction(obj) {
        try {
            const { data } = await axios.post("tasktodo/doaction", obj);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async mypending(obj) {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const { data } = await axios.get(`tasktodo/mypending${str}`);
            const { meta, list } = data;
            obj.total = meta.total;
            return list;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async teampending(obj) {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const { data } = await axios.get(`tasktodo/teampending${str}`);
            const { meta, list } = data;
            obj.total = meta.total;
            return list;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async approvalhistory(obj) {
        try {
            const { data } = await axios.get(`tasktodo/history/${obj.key}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async approvalprint(obj) {
        try {
            const url = `/tasktodo/historyprint/${obj.key}`;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            return link;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async viewBudgetDept(obj = {}) {
        try {
            const keys = ['departkd', 'departemen', 'tahun', 'layout'];
            let str = '?';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/budgetdept/viewprint${str}`;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            return link;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async attachmentSave(formData) {
        try {
            const { data } = await axios.post("tasktodo/attachment", formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async attachmentDownload(obj) {
        let url;
        try {
            const response = await axios({
                url: `/tasktodo/attachment/${obj.attachmentKey}`,
                method: 'GET',
                responseType: 'blob',
            });
            url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', obj.attchFileNm || 'attachment');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Delay revocation to ensure browser handles the download
            setTimeout(() => window.URL.revokeObjectURL(url), 100);
            return true;
        } catch (error) {
            if (url) window.URL.revokeObjectURL(url);
            throw error;
        }
    },
    async getAttachment(obj) {
        try {
            const { data } = await axios.get(`/tasktodo/attachmentlist/${obj.taskkey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async delAttachment(obj) {
        try {
            const { data } = await axios.delete(`/tasktodo/attachment/${obj.attachmentKey}`);
            return data;
        } catch (error) {
            await errorHandler(error);
        }
    },
    async exportxls(obj = {}) {
        let url;
        try {
            const keys = ['tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const response = await axios({
                url: `/apreval/exportxls${str}`,
                method: 'GET',
                responseType: 'blob',
            });
            url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'apreval_list.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => window.URL.revokeObjectURL(url), 100);
            return true;
        } catch (error) {
            if (url) window.URL.revokeObjectURL(url);
            throw error;
        }
    }
};